'use client'

import CustomCarousel from '../CustomCarousel'
import React, { useMemo, useRef, useState } from 'react'
import Testimonial from './Testimonial'
import useIsMobile from '@/hooks/useIsMobile'
import { TestimonialProps, TestimonialSectionProps } from '@/widgets/landing-page-widgets/TestimonialSection/schema'
import styles from './styles.module.css'
import { cn, Typography } from '@pw-tech/omni-ui'

const TestimonialSection = ({ testimonialData }: { testimonialData: TestimonialSectionProps }) => {
  const [playingInd, setPlayingInd] = useState(-1)

  const { isMobile } = useIsMobile()
  const testimonials = testimonialData?.testimonials || []
  const sliderRef = useRef(null)

  const slidesToShow = useMemo(() => {
    if (isMobile) {
      return testimonials?.length <= 2 ? testimonials?.length : 1.1
    }

    if (testimonialData?.isMLP) {
      return 2.6
    }

    return 4
  }, [isMobile, testimonials?.length, testimonialData?.isMLP])

  const updatePlayingInd = (p: React.SetStateAction<number>) => {
    setPlayingInd(p)
  }

  const arrows =
    isMobile || testimonialData?.isMLP ? (testimonials?.length || 0) <= 2 : (testimonials?.length || 0) <= 4

  return (
  <div className={cn('py-6 md:py-[60px]', testimonialData?.isMLP && '!pb-0')}>
  <div className={cn('max-w-6xl mx-auto', !testimonialData?.isMLP && 'px-4 md:px-6')}>
        <Typography
          variant={testimonialData?.isMLP ? 'heading3' : 'heading2'}
          className="mb-2 text-center"
          weight='bold'
          color='#1b2124'
        >
          {testimonialData.heading}
        </Typography>

  <Typography variant='heading4' className="text-center" color='#3d3d3d'>
          {testimonialData.subHeading}
        </Typography>

  <div className="mt-6 md:mt-12">
          <CustomCarousel
            items={testimonials}
            renderCarouselItem={(
              item: TestimonialProps,
              meta: { index: number; activeIndex: number; slidesToShow: number },
            ) => {
              const { index } = meta
              return (
                <Testimonial
                  key={item?.title}
                  index={index}
                  item={item}
                  updatePlayingInd={updatePlayingInd}
                  isPlaying={index === playingInd}
                />
              )
            }}
            ref={sliderRef}
            slidesToShow={slidesToShow}
            arrows={!arrows} // Inverted since original logic was for "hide arrows"
            data={testimonialData}
          />
        </div>
      </div>
    </div>
  )
}

export default TestimonialSection
